import { SurchargeContainer } from "src/containers/Surcharge";

const SurchargePage = (props) => {
  return <SurchargeContainer />;
};

export default SurchargePage;
